import React from 'react';
import { get as lodash_get, head as lodash_head } from 'lodash';
import CheckoutBatterieDeposit from '../../Checkout/CheckoutComponents/CheckoutBatterieDeposit';

import Image from '../../../components/Image/Image';
import Currency from '../../../../helpers/currency';
import { InternalLink } from '../../../components/form-elements/Link';

const tibs_main = 'https://www.tibsonline.de/AddvMultimedia/';
const blob_main = 'https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/articles/';
const blobOwnTire = 'https://techno-images.s3.eu-central-1.amazonaws.com/images/reifen/eigenerReifen.png';
const blobOwnArticle = 'https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/';
const blobLogo = 'https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/';

function changeProductQuantity(updateItem, product, value) {
    product.quantity = value;
    updateItem({ product });
}

function createMarkup(markup) {
    return { __html: markup };
}

function ArticleRow({
    isCart,
    productType,
    imageSrc,
    productText,
    productDescription,
    productQuantity,
    productSinglePrice,
    product,
    standortUrl,
    productShipmentDetails,
    removeProduct,
    updateItem,
    legalType,
}) {
    let limit = (!product.stock || product.stock > 999) ? 1000 : product.stock;
    let cTypeLimit = (!product.stock || product.stock > 3) ? 4 : product.stock;
    const to = product.href || `/${product.categoryUrl}/${product.slug || product.id}`;
    return (
        <div className="checkout_product ">
            {isCart && (
                <div className="uk-width-1-1 uk-flex uk-flex-right">
                    <button className="button-delete" onClick={() => removeProduct({ product })}>
                        <i className="fa fa-times" aria-hidden="true" />
                    </button>
                </div>
            )}
            <div className="product__image">
                <InternalLink to={to} modifier="reset">
                    <Image src={imageSrc} alt="product_image" resizeWidth={200} />
                </InternalLink>
            </div>
            <div className="product__text">
                <div className="text-name">
                    <InternalLink to={to} modifier="reset">
                        <b dangerouslySetInnerHTML={createMarkup(productText)} />
                    </InternalLink>
                </div>
                <div className="text-description" dangerouslySetInnerHTML={createMarkup(productDescription)} />
                <div className="text-quantity uk-flex uk-width-1-1">
                    <div className="uk-flex-left">Menge:</div>
                    <div className="quantity-modifier">
                        {isCart && productType !== 'service' ? (
                            <>
                                <button
                                    className="button-update-quantity"
                                    onClick={() => {
                                        if (product.quantity - 1 > 0)
                                            changeProductQuantity(updateItem, product, Number(product.quantity) - 1);
                                    }}
                                >
                                    <i className="fa fa-minus" aria-hidden="true" />
                                </button>
                                {/*ToDo: Ist das ein inputFeld?*/}
                                <span>{productQuantity}</span>
                                <button
                                    className="button-update-quantity"
                                    onClick={() => {
                                        if (product.selectedLieferweg.abcKategorie === 'C' && product.quantity === cTypeLimit)
                                            window.UIkit.notification(`Maximale Menge: ${cTypeLimit}. Aktuell bereits im Warenkorb: ${cTypeLimit}`, {
                                                status: 'danger',
                                                pos: 'top-right',
                                            });
                                        else if (product.selectedLieferweg.abcKategorie !== 'C' && product.quantity === limit)
                                            window.UIkit.notification(`Maximale Menge: ${limit}. Aktuell bereits im Warenkorb: ${limit}`, {
                                                status: 'danger',
                                                pos: 'top-right',
                                            });
                                        else if (product.selectedLieferweg.abcKategorie === 'C' && product.quantity + 1 <= 4) {
                                            changeProductQuantity(updateItem, product, Number(product.quantity + 1));
                                        } else if (product.selectedLieferweg.abcKategorie !== 'C' && product.quantity + 1 <= 1000)
                                            changeProductQuantity(updateItem, product, Number(product.quantity) + 1);
                                    }}
                                >
                                    <i className="fa fa-plus" aria-hidden="true" />
                                </button>
                                <p> </p>
                            </>
                        ) : (
                            <>{productQuantity}</>
                        )}
                    </div>
                </div>
                <div className="text-price">
                    <div>
                        <span>
                            {legalType === 'reservierung' ? 'Unser Preisangebot –' : 'Einzelpreis'} <br />
                        </span>
                        {legalType === 'reservierung' ? <span>zahlbar vor Ort:</span> : <Currency quantity={productSinglePrice} />}
                    </div>
                    <div>
                        <span>
                            Preis <br />
                        </span>
                        <b>
                            <Currency quantity={productSinglePrice * productQuantity} />
                        </b>
                    </div>
                </div>
            </div>
            {productShipmentDetails}
        </div>
    );
}

function deliveryTime(product) {
    const { deliveryDaysFrom, deliveryDaysTo } = product;

    if (deliveryDaysFrom > 0 && deliveryDaysTo > 0) {
        return `${deliveryDaysFrom}-${deliveryDaysTo} Werktage`;
    }

    if (deliveryDaysFrom === 1) {
        return `${deliveryDaysFrom} Werktag`;
    } else if (deliveryDaysFrom > 0) {
        return `${deliveryDaysFrom} Werktage`;
    }


    if (deliveryDaysTo === 1) {
        return `${deliveryDaysTo} Werktag`;
    } else if (deliveryDaysTo > 0) {
        return `${deliveryDaysTo} Werktage`;
    }

    return '3-5 Werktage';
}

function pickupTime(product) {
    if (!product) return null;

    const { pickupDaysFrom, pickupDaysTo } = product;

    if (pickupDaysFrom > 0 && pickupDaysTo > 0) {
        return `${pickupDaysFrom}-${pickupDaysTo} Werktagen`;
    }

    if (pickupDaysFrom === 1) {
        return `${pickupDaysFrom} Werktag`;
    } else if (pickupDaysFrom > 0) {
        return `${pickupDaysFrom} Werktagen`;
    }

    if (pickupDaysTo === 1) {
        return `${pickupDaysTo} Werktag`;
    } else if (pickupDaysTo > 0) {
        return `${pickupDaysTo} Werktagen`;
    }

    return '3-5 Werktagen';
}

function returnProductShipmentDetails(product, type, markenStandort) {
    if (type && type === 'product' && lodash_get(product, 'selectedLieferweg.legalType', '') === 'online-kauf')
        return (
            <div className="shipment_details">
                <div className="divider" />
                <p>Lieferzeit: {deliveryTime(product)}</p>
                <p>
                    Versand durch:{' '}
                    {product && product.abcKategorie && product.abcKategorie === 'D'
                        ? lodash_get(markenStandort, 'anschrift.firma', '')
                        : 'AutoteilePlusService'}
                </p>
                <p>Verkauf durch: {lodash_get(markenStandort, 'anschrift.firma', '')}</p>
            </div>
        );
}

function returnProductShipmentDetailsReservation(product, type, markenStandort) {
    if (type && type === 'product' && lodash_get(product, 'selectedLieferweg.legalType', '') === "reservierung")
        return (
            <div className="shipment_details">
                <div className="divider" />
                <p>Abholbereit in: {pickupTime(product)}</p>
                <p>Verkauf durch: {lodash_get(markenStandort, 'anschrift.firma', '')}</p>
            </div>
        );
}

function getProductImage(product, markenStandort) {
    const first_image = lodash_head(product.images);
    const { gesellschafterNr, standortNr } = markenStandort;
    const standort_logo_url = `${gesellschafterNr}/${standortNr}/Logo.jpg`;
    if (product.isOwnArticle || product.elementType === 'service' || !product.blobUrl) {
        if (product.images && product.images.length > 0 && first_image) {
            // todo: temporary hotfix for image src including origin.
            if (typeof first_image === 'string') {
                return first_image;
            }
            return blobOwnArticle + first_image.name;
        } else {
            return product.elementType === 'service' ? product.bilddatei || blobLogo + standort_logo_url : blobOwnTire;
        }
    } else {
        return product.blobUrl ? blob_main + product.blobUrl : tibs_main + product.picFrontFace;
    }
}

/*
 * cart is a variable that consists of the desctructered cart,markenStandort.
 *  And if the component is accessed by the cart then there is also standortUrl, removeProduct and updateItem
 * */
const CheckoutProducts = cart => (
    <div className="line">
        {cart &&
            cart.products &&
            cart.products.map((product, index) => (
                <>
                    <div key={index} className="uk-flex uk-flex-wrap">
                        {cart.type !== 'cart' && cart.showHeader ? (
                            <div className="uk-flex uk-flex-middle checkout_list_header">
                                <p className="uk-margin-remove">
                                    <>
                                        <i className="fa fa-list" aria-hidden="true" />
                                        Artikel {index + 1} von {cart.products.length}
                                    </>
                                </p>
                            </div>
                        ) : null}
                        <div className={`checkout_confirm_products uk-margin${cart.hideHeader ? +'uk-remove-margin-horizontal' : ''}`}>
                            <div key={product._id} className="checkout_confirm_products_inner">
                                {product && (
                                    <ArticleRow
                                        isCart={cart && cart.type === 'cart'}
                                        productType={product.elementType}
                                        // Eigene Artikel oder Services benutzen bilddatei, eigene Reifen benutzuen blob own Tire, picFrontFace sind nicht eigene Artikel Reifen.
                                        imageSrc={getProductImage(product, cart && cart.markenStandort)}
                                        //service: service title, default: bezeichnung
                                        productText={product.serviceTitle || product.bezeichnung}
                                        //service: fahrzeugBeschreibung, produkt : (shownId sind eigene Artikel) product.id, felge: product.bezeichnung eigentlich, wird aber id nun zurückgegeben
                                        productDescription={
                                            product.id && product.elementType !== 'service'
                                                ? `Artikelnr.  ${product.shownId || product.id}`
                                                : product.fahrzeugBeschreibung || product.bezeichnung
                                        }
                                        productQuantity={product.quantity || 1}
                                        // felge : vk_preis/ 100, reifen : selectedBezugsquelle.vk_preis, product: vk_preis, service: product.preis.komplettPreis
                                        productSinglePrice={
                                            product.elementType === 'felge'
                                                ? product.vk_preis / 100 +
                                                (lodash_get(product, 'selectedLieferweg.type') === 'werkstatt'
                                                    ? lodash_get(product, 'warengruppe.service_preis')
                                                    : 0)
                                                : (product.selectedBezugsquelle && product.selectedBezugsquelle.vk_preis) ||
                                                product.vk_preis ||
                                                (product.preis && product.preis.komplettPreis)
                                        }
                                        productShipmentDetails={
                                            cart &&
                                            cart.type !== 'cart' &&
                                            (returnProductShipmentDetails(product, product.elementType, cart && cart.markenStandort) ||
                                                returnProductShipmentDetailsReservation(product, product.elementType, cart && cart.markenStandort))
                                        }
                                        standortUrl={cart.standortUrl}
                                        product={product}
                                        removeProduct={cart.removeProduct}
                                        updateItem={cart.updateItem}
                                        legalType={cart.legalType}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    {product.articleType === "batterie" && (
                        <div>
                            <CheckoutBatterieDeposit product={product} />
                        </div>
                    )}
                </>
            )
            )}
    </div>
);

export default CheckoutProducts;
